import { CheckCircle, AlertCircle, Loader } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ActivationLoading = () => (
  <div className="text-center py-12">
    <Loader className="w-12 h-12 text-teal-600 animate-spin mx-auto mb-4" />
    <p className="text-gray-600">Activation de votre compte en cours...</p>
  </div>
);

export const ActivationSuccess = ({ onNavigate }) => (
  <div className="text-center py-8">
    <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
    <h2 className="text-2xl font-bold text-gray-900 mb-2">Compte activé !</h2>
    <p className="text-gray-600 mb-6">
      Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter.
    </p>
    <Link
      to="/"
      onClick={onNavigate}
      className="inline-block bg-teal-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-teal-700 transition-colors"
    >
      Aller à la connexion
    </Link>
  </div>
);

export const ActivationError = ({ errorMessage }) => (
  <div className="text-center py-8">
    <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
    <h2 className="text-2xl font-bold text-gray-900 mb-2">Erreur d'activation</h2>
    <p className="text-gray-600 mb-6">{errorMessage}</p>
    <div className="space-y-3">
      <Link
        to="/"
        className="block bg-teal-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-teal-700 transition-colors"
      >
        Aller à la connexion
      </Link>
      <Link
        to="/inscription-admin"
        className="block bg-gray-200 text-gray-900 px-6 py-2.5 rounded-lg font-medium hover:bg-gray-300 transition-colors"
      >
        Créer un nouveau compte
      </Link>
    </div>
  </div>
);

export const ActivationInvalidToken = () => (
  <div className="text-center py-8">
    <AlertCircle className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
    <h2 className="text-2xl font-bold text-gray-900 mb-2">Lien invalide</h2>
    <p className="text-gray-600 mb-6">
      Le lien d'activation est invalide ou a expiré.
    </p>
    <Link
      to="/inscription-admin"
      className="inline-block bg-teal-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-teal-700 transition-colors"
    >
      S'inscrire à nouveau
    </Link>
  </div>
);
